import axios from 'axios';

export const PRYSME_ACCESS_APP_ID =
  process.env.REACT_APP_PRYSME_ACCESS_APP_ID || '2d8b209e-44bb-4b31-b569-45dbc8169a81';

export function isPrysmeAccessApp(app) {
  if (!app) return false;
  if (String(app.id) === PRYSME_ACCESS_APP_ID) return true;
  const name = String(app.name || '')
    .toLowerCase()
    .replace(/[''´`]/g, "'");
  return name.includes('prysme access') || name.includes("prysme'access");
}

export function buildApplicationSsoUrl(app, user, ssoToken) {
  if (!app?.url) return null;

  if (app.sso_url_template) {
    let template = app.sso_url_template;
    template = template.replace(/{TOKEN}/gi, ssoToken);
    template = template.replace(/{USERNAME}/gi, user?.username || '');
    template = template.replace(/{EMAIL}/gi, user?.email_principal || user?.email_secondaire || '');
    template = template.replace(/{USER_ID}/gi, user?.id || '');
    template = template.replace(/{FIRST_NAME}/gi, user?.first_name || '');
    template = template.replace(/{LAST_NAME}/gi, user?.last_name || '');

    const baseUrl = app.url.endsWith('/') ? app.url.slice(0, -1) : app.url;
    const templatePath = template.startsWith('/') ? template : `/${template}`;
    return baseUrl + templatePath;
  }

  const separator = app.url.includes('?') ? '&' : '?';
  return `${app.url}${separator}sso_token=${ssoToken}`;
}

export async function openPrysmeAccessApp({ API, user, applications = null }) {
  const token = sessionStorage.getItem('token');
  if (!token) throw new Error('Session expirée');

  let apps = applications;
  if (!apps) {
    const res = await axios.get(`${API}/applications`);
    apps = res.data;
  }

  const app = (apps || []).find(isPrysmeAccessApp);
  if (!app) throw new Error("Application Prysme Access introuvable");

  const ssoResponse = await axios.post(`${API}/auth/sso-token?token=${token}`);
  const ssoUrl = buildApplicationSsoUrl(app, user, ssoResponse.data.sso_token);
  if (!ssoUrl) throw new Error('URL SSO invalide');

  window.open(ssoUrl, '_blank');
}
